/**
 * @flow
 * @relayHash 2cf8d362a1e5bdaa36642c147a19d825
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteContactMediumMutationVariables = {|
  id: string
|};
export type DeleteContactMediumMutationResponse = {|
  +deleteContactMedium: {|
    +id: string
  |}
|};
export type DeleteContactMediumMutation = {|
  variables: DeleteContactMediumMutationVariables,
  response: DeleteContactMediumMutationResponse,
|};
*/


/*
mutation DeleteContactMediumMutation(
  $id: String!
) {
  deleteContactMedium(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteContactMedium",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ContactMediumModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteContactMediumMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteContactMediumMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteContactMediumMutation",
    "id": null,
    "text": "mutation DeleteContactMediumMutation(\n  $id: String!\n) {\n  deleteContactMedium(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0e06be80ca696458cf56e66de9637eca';
module.exports = node;
